export const galleryImages = [
  {
    original: `${process.env.REACT_APP_IMAGEKIT_URL}/tr:w-700/salon-app/shwang.jpg`,
    thumbnail: `${process.env.REACT_APP_IMAGEKIT_URL}/salon-app/shwang.jpg`,
  },
  {
    original: `${process.env.REACT_APP_IMAGEKIT_URL}/tr:w-700/salon-app/red.jpg`,
    thumbnail: `${process.env.REACT_APP_IMAGEKIT_URL}/salon-app/red.jpg`,
  },
  {
    original: `${process.env.REACT_APP_IMAGEKIT_URL}/tr:w-700/salon-app/long-mesh.jpg`,
    thumbnail: `${process.env.REACT_APP_IMAGEKIT_URL}/salon-app/long-mesh.jpg`,
  },
  {
    original: `${process.env.REACT_APP_IMAGEKIT_URL}/tr:w-700/salon-app/back-view-afro-hairstyle.jpg`,
    thumbnail: `${process.env.REACT_APP_IMAGEKIT_URL}/salon-app/back-view-afro-hairstyle.jpg`,
  },
  {
    original: `${process.env.REACT_APP_IMAGEKIT_URL}/tr:w-700/salon-app/posing-together.jpg`,
    thumbnail: `${process.env.REACT_APP_IMAGEKIT_URL}/salon-app/posing-together.jpg`,
  },
  {
    original: `${process.env.REACT_APP_IMAGEKIT_URL}/tr:w-700/salon-app/woman-with-braids.jpg`,
    thumbnail: `${process.env.REACT_APP_IMAGEKIT_URL}/salon-app/woman-with-braids.jpg`,
  },
  {
    original: `${process.env.REACT_APP_IMAGEKIT_URL}/tr:w-700/salon-app/black-face-mask-lady.jpg`,
    thumbnail: `${process.env.REACT_APP_IMAGEKIT_URL}/salon-app/black-face-mask-lady.jpg`,
  },
  {
    original: `${process.env.REACT_APP_IMAGEKIT_URL}/tr:w-700/salon-app/fine-smiling-woman.jpg`,
    thumbnail: `${process.env.REACT_APP_IMAGEKIT_URL}/salon-app/fine-smiling-woman.jpg`,
  },
];
